/**
 * © [2020] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';
import _ from 'lodash';
import { Button } from 'react-bootstrap';
import Spinner from '../../../../../SharedModules/Spinner/SpinnerNew';
import CustomSeparator from '../../../../../SharedModules/Breadcrumbs/BreadcrumbsComponent';
import SelectedClaimHeader from './SelectedClaimHeader';
import SelectedClaimTabContainer from './SelectedClaimTabContainer';
import DisplayErrorMessages from '../../../../../SharedModules/Errors/ErrorMessages';
import SVGComponent from '../../../../../SharedModules/SVGComponents/SVGComponents';
import SaveCancelPopup from '../../../../../SharedModules/CustomSaveCancelPopup/SaveCancelPopup';
import { getgeneralsystemparameterDetails } from '../../../../Display/Check/store/action';
import { getOverrideSystemData } from '../../../RebateProgram/MaintainRebate/store/actions';
import {
  PostNumOfUnits,
  resetEditedRows,
  setDisabled,
  setErrorMessage,
  setNumOfUnitRes,
  setNumOfUnitsExtraState,
  searchClaimByNDC,
  GetAndDispatchClaimByID,
  setSelectedClaimNu,
  setTableDataNu,
  setCellFocused,
  getSinglePageClaimData,
  setSinglePageClaimDataNu,
  getNOUClaimTableInfo,
  getAllClaimReferenceData,
  handleSelectChangeFilter,
  setSelectedClaimModeNu,
  setEditedRows,
} from '../../store/action';
import { formatDateUnix } from '../../../../../SharedModules/utilities/dateUtilities';
import {
  FAIL_PROCESSING_REQUEST,
  SUPPLEMENTAL,
} from '../../../../../SharedModules/Errors/constantMessageData';
import DisplaySuccessMessages from '../../../../../SharedModules/Errors/SuccessMessage';
import {
  closeTab,
  handleScrollToEvent,
} from '../../../../../SharedModules/CommonUtilities/commonUtilities';
import * as constantMessageData from '../../../../../SharedModules/Errors/constantMessageData';

const UnitsSelectedClaim = () => {
  const dispatch = useDispatch();
  const history = useHistory();

  // const selectedClaim = useSelector(
  //   (state) => state.sharedState.NumberOfUnits.selectedClaim
  // );
  const {
    selectedClaimIndex = 1,
    pageClaimDataNu,
    selectedClaimNu = [],
  } = useSelector((state) => state.sharedState.NumberOfUnits);

  const { selectBy } = useSelector((state) => state.sharedState.NumberOfUnits);

  const claimReferenceData = useSelector(
    (state) => state.sharedState.NumberOfUnits.claimReferenceData
  );
  const getNouClaimInfo = useSelector(
    (state) => state.sharedState.NumberOfUnits.getNouClaimInfo
  );

  const systemParameter = useSelector(
    (state) => state.sharedState.displayCheck.systemParameter
  );

  const claimSelectByFilter = useSelector(
    (state) => state.sharedState.NumberOfUnits.claimSelectByFilter
  );

  const tableData = useSelector(
      (state) => state.sharedState.NumberOfUnits.tableDataNu
    );
  const searchScreenReduxObj = useSelector(
    (state) => state.sharedState.NumberOfUnits?.searchScreenReduxObj
  );
  const disableBtn = useSelector(
    (state) => state.sharedState.NumberOfUnits.disableBtn
  );

  const selectedClaimModeNu = useSelector(
    (state) => state.sharedState.NumberOfUnits.selectedClaimModeNu
  );
  const spinnerLoader = useSelector((state) => {
    return state?.sharedState.showPreLoader?.showPreLoader;
  });

  const editedData = useSelector((state) => {
    return state.sharedState.NumberOfUnits.editedData;
  });
  const unitResponse = useSelector((state) => {
    return state.sharedState.NumberOfUnits.unitResponse;
  });

  const isChecked = useSelector(
    (state) => state.sharedState.NumberOfUnits.disputeResolutionToggle
  );

  const errorPopupMessage = useSelector(
    (state) => state.sharedState.NumberOfUnits.errorPopupMessage
  );

  const extraState = useSelector(
    (state) => state.sharedState.NumberOfUnits.extraState
  );
  const edit = useSelector(
    (state) => state.sharedState.NumberOfUnits.extraState.edit
  );
  const rebateType = useSelector(
    (state) => state.sharedState.NumberOfUnits?.rebateType
  );
  // const selectBy = useSelector(
  //   (state) => state.sharedState.NumberOfUnits.selectBy
  // );
  const logInUser = useSelector(
    (state) => state?.sharedState?.SharedReducer?.logInUser
  );
  const errorMessage = useSelector(
    (state) => state.sharedState.NumberOfUnits.errorMessage
  );
  const userId = useSelector(
    (state) =>
      state?.sharedState?.UserDefaultReducer?.UserDefaultsValues?.data?.userId
  );
  const setStateChange = (key, val) => {
    setState({
      ...extraState,
      [key]: val,
    });
  };

  const setState = (value) => dispatch(setNumOfUnitsExtraState(value));
  const localStore = JSON.parse(localStorage.getItem('tabItemsData'));
  const [isMounted, setIsMounted] = useState();
  const [fullScreen, setFullScreen] = useState(false);
  const [tableFullScreen, setTableFullScreen] = useState(false);
  const [oldSelectedClaim, setOldSelectedClaim] = useState(null);

  // const [disableBtn, setDisableBtn] = useState(true);
  const [successMessages, setSuccessMessages] = React.useState([]);
  const [open, setOpen] = useState(false);
  const [openCancel, setOpenCancel] = useState(false);
  const [willCloseTab, setWillCloseTab] = useState(false);
  const [beforeSaveModeVal, setBeforeSaveModeVal] = useState('');

  React.useEffect(() => {
    if (
      tableData &&
      errorMessage &&
      typeof errorMessage === "string" &&
      errorMessage.trim().length > 0 &&
      errorMessage === constantMessageData.FAILED_MESSAGE_GENERIC
    ) {
      resetForm();
    }
  }, [errorMessage]);
  
  React.useEffect(() => {
    if (!claimReferenceData) {
      dispatch(getAllClaimReferenceData());
      dispatch(handleSelectChangeFilter(null, 'claimCategoryCd', 'ALL'));
    }
  }, [claimReferenceData]);
  useEffect(() => {
    dispatch(getgeneralsystemparameterDetails());
    dispatch(getOverrideSystemData({}));
    dispatch(setErrorMessage([]));
    dispatch(setDisabled(true));
  }, []);

  const getPageClaimsData = () => {
    if (selectedClaimNu.length > 0) {
      const claimList =
        selectBy === 'claimId'
          ? selectedClaimNu[selectedClaimIndex - 1]?.claimVOList
          : selectedClaimNu[selectedClaimIndex - 1]?.claimResultVOList;
   
      const payload = claimList?.map((item) => ({
        claimId: item.claimIdVO?.claimId ?? item.claimId,
        claimLineNum: item.claimIdVO?.claimLineNum ?? item.claimLineNum,
        userID: logInUser?.toUpperCase(),
        functionCode: 'Number Of Units',
        eventInquryKeyVO: [
          {
            keyType: 'claimId',
            key: `${item.claimIdVO?.claimId ?? item.claimId}-${
              item.claimIdVO?.claimLineNum ?? item.claimLineNum
            }`,
          },
        ],
      }));
   
      if (payload?.length) {
        dispatch(getSinglePageClaimData(payload));
      }
    }
  };
  // useEffect(() => {
  //   getPageClaimsData();
  // }, [selectedClaimIndex, selectedClaim]);

  React.useEffect(() => {
    if (getNouClaimInfo) {
      dispatch(getNOUClaimTableInfo(false));
      getPageClaimsData();
    }
  }, [getNouClaimInfo]);
  React.useEffect(() => {
    if (rebateType === 'Supplemental') {
      dispatch(setSelectedClaimModeNu('display'));
    }
  }, [rebateType]);

  // handling refresh functionality
  useEffect(() => {
    const updateTabs = JSON.parse(localStorage.getItem('tabItemsData'));
    const newObj =
      updateTabs &&
      updateTabs.length > 0 &&
      updateTabs?.map((item) => {
        if (item.navTo === '/units-claim') {
          if (errorPopupMessage?.length > 0) {
            item.isFormError = true;
          } else {
            item.isFormError = false;
          }
        }
        return item;
      });
    localStorage.setItem('tabItemsData', JSON.stringify(newObj));
  }, [errorPopupMessage]);

  // Tab highlighter POC
  React.useEffect(() => {
    const errMsg = errorPopupMessage;
    const updateTabs = JSON.parse(localStorage.getItem('tabItemsData'));
    const newObj =
      updateTabs &&
      updateTabs.length > 0 &&
      updateTabs.map((item) => {
        if (item.navTo === '/units-selected-claim' && edit) {
          item.isFormDirty = true;
        } else {
          item.isFormDirty = false;
        }
        if (item.navTo === '/units-selected-claim') {
          if (edit && !_.isEmpty(errMsg)) {
            item.isFormError = true;
            dispatch(setErrorMessage([]));
          } else {
            item.isFormError = false;
          }
        }
        return item;
      });
    localStorage.setItem('tabItemsData', JSON.stringify(newObj));
  }, [edit, errorPopupMessage]);

  // Close Popup POC---
  useEffect(() => {
    setIsMounted(true);
  }, []);

  const saveAndCloseTab = () => {
    setWillCloseTab(true);
    saveUnits();
  };

  useEffect(() => {
    if (isMounted) {
      const updateTabs = JSON.parse(localStorage.getItem('tabItemsData'));
      if (
        updateTabs &&
        updateTabs.length > 0 &&
        updateTabs.filter((x) => {
          return x.navTo === '/units-selected-claim' && x.isFormSave;
        }).length > 0
      ) {
        const newObj = updateTabs.map((item) => {
          if (item.navTo === '/units-selected-claim' && item.isFormSave) {
            item.isFormSave = false;
            saveAndCloseTab();
          }
          return item;
        });
        localStorage.setItem('tabItemsData', JSON.stringify(newObj));
      }
    }
  }, [JSON.parse(localStorage.getItem('tabItemsData'))]);

  const openSave = () => {
    setSuccessMessages([]);
    dispatch(setErrorMessage([]));
    setOpen(true);
  };

  function resetForm() {
    setSuccessMessages([]);
    dispatch(setCellFocused(-1));
    // const clone = JSON.parse(JSON.stringify(reportQtr));
    // setReportQtrDetailList({ ...clone });
    setOpenCancel(false);
    dispatch(resetEditedRows());
    dispatch(setDisabled(true));
    dispatch(setSelectedClaimNu(JSON.parse(JSON.stringify([...selectedClaimNu]))));
    getPageClaimsData();
    setBeforeSaveModeVal('');
    // setDisableBtn(true);
  }

  useEffect(() => {
    setOldSelectedClaim([...selectedClaimNu]);
    handleScrollToEvent();
  }, []);

  const saveUnits = async () => {
    const payloadData = [];
    dispatch(setNumOfUnitRes([]));
    editedData.forEach((el) => {
      payloadData.push({
        drugSeqNum: el.drugSeqNum,
        qtr: el.paidQtr,
        claimId: el.claimIdVO.claimId,
        claimLineNum: el.claimIdVO.claimLineNum,
        rebateProgramCd: el.rebateProgramCd,
        labelerCode: el.labelerCode,
        date: formatDateUnix(el.paidDt),
        numOfUnits: el.numOfUnits,
        billedUnits: parseFloat(el.billedUnits),
        contractSeqNum: '',
        isibwdndc: searchScreenReduxObj?.isibwdndc || false,
        isibwdclaim: searchScreenReduxObj?.isibwdclaim || false,
        wdstatuscd: el.wdStatusCd,
        paidQtr: el.paidQtr,
        dramsQtr: null,
        ildisputeresolution: isChecked == true ? 1 : 0,
        unitsModFromArInd: el.unitsModFromArInd,
        planTypeCd: rebateType === 'Supplemental' ? SUPPLEMENTAL : '',
        userInput: 'yes',
        claimLoadDt: formatDateUnix(el.claimLoadDt),
        corrLinkId: el.corrLinkId,
        userId: userId,
      });
    });

    if (payloadData.length > 0) {
      await dispatch(PostNumOfUnits(payloadData));
    }

    dispatch(setEditedRows([])); // Dispatch to clear editedData in the Redux store

    await dispatch(setDisabled(true));
      dispatch(
              setSinglePageClaimDataNu(
                tableData
              )
            );
    setStateChange('edit', false);
    setOpen(false);
    // dispatch(resetEditedRows());
    // if (selectBy === 'ndc') {
    //   dispatch(searchClaimByNDC(false));
    // }
    // if (selectBy === 'claimId') {
    //   dispatch(GetAndDispatchClaimByID(objClaimId, null, false));
    // }

    dispatch(setCellFocused(-1));
  };

  useEffect(() => {
    if (unitResponse?.status === '200') {
      if (willCloseTab) {
        closeTab('/units-selected-claim', history, dispatch);
      }
      if (beforeSaveModeVal) {
        dispatch(setSelectedClaimModeNu(beforeSaveModeVal));
      }
      setSuccessMessages([[constantMessageData.SUCCESSMESSAGE_GENERIC]]);
      getPageClaimsData();
    //  // setTimeout(() => setSuccessMessages([]), 5000);
    } else if (unitResponse?.status === '003') {
      dispatch(setErrorMessage([unitResponse?.message]));
    } else if (unitResponse?.status === '002' && !unitResponse?.message) {
      dispatch(setErrorMessage([FAIL_PROCESSING_REQUEST]));
    }
    // getPageClaimsData();
    return () => {
      dispatch(setNumOfUnitRes({}));
    };
  }, [unitResponse?.status]);

  return (
    <div className="tabs-container tBillPanel custom-check">
      <Spinner load={spinnerLoader} />
      <SaveCancelPopup
        open={open}
        title="Save"
        onConfim={() => {
          saveUnits();
          setOpen(false);
        }}
        onCancel={() => {
          setOpen(false);
        }}
      />
      <SaveCancelPopup
        open={openCancel}
        title="Cancel"
        onConfim={() => {
          resetForm();
        }}
        onCancel={() => {
          setOpenCancel(false);
        }}
      />
      <CustomSeparator
        parent1="Maintain"
        parent2="Number of Units"
        parent3="Select Claim for Maintain"
        parent4="Selected Claim"
      />
      {successMessages && (
        <DisplaySuccessMessages
          successMessages={
            typeof successMessages === 'string'
              ? [successMessages]
              : successMessages
          }
        />
      )}
      {errorMessage && (
        <DisplayErrorMessages
          errorMessages={
            typeof errorMessage === 'string' ? [errorMessage] : errorMessage
          }
        />
      )}

      <div className="row">
        {!fullScreen && !tableFullScreen && (
          <SelectedClaimHeader
            data={selectedClaimNu}
            pageClaimData={pageClaimDataNu}
            currentIndex={selectedClaimIndex - 1}
            setErrorMessage={setErrorMessage}
            claimSelectByFilter={claimSelectByFilter}
            setSuccessMessages= {setSuccessMessages}
            successMessages={successMessages}
          />      
        )}
        <SelectedClaimTabContainer
          fullScreen={fullScreen}
          setFullScreen={setFullScreen}
          data={pageClaimDataNu}
          currentIndex={0}
          claimReferenceData={claimReferenceData}
          tableFullScreen={tableFullScreen}
          setTableFullScreen={setTableFullScreen}
          systemParameter={systemParameter}
          claimSelectByFilter={claimSelectByFilter}
          setStateChange={setStateChange}
          setErrorMessage={setErrorMessage}
          disableBtn={disableBtn}
          setBeforeSaveModeVal={setBeforeSaveModeVal}
          successMessages={successMessages}
          setSuccessMessages= {setSuccessMessages}
          handleOpenSave={() => {
            openSave();
          }}
        />
      </div>

      {selectedClaimModeNu != 'display' && (
        <div className="row">
          <div className="col-sm-12">
            <div className="float-right mb-3">
              <div className="btn-wrapper mt-3">
                <Button
                  className="btn btn-success btn-search"
                  onClick={openSave}
                  data-testid="openSave"
                  disabled={disableBtn}
                >
                  <SVGComponent iconName="Icon-awesome-save" /> Save
                </Button>
                <Button
                  className="btn btn-cancel"
                  onClick={() => {
                    setOpenCancel(true);
                  }}
                  disabled={disableBtn}
                >
                  <SVGComponent iconName="Icon-cancel" /> Cancel
                </Button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default UnitsSelectedClaim;
